import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import HelpLink from 'App/HelpLink';
import {
  StatisticsPage,
  AcquisitionSummaryCard,
} from 'domains/Statistics/components';
import { useTranslationStatistics } from 'domains/Statistics/hooks';

function StatisticsAcquisitionPage() {
  const t = useTranslationStatistics();
  return (
    <StatisticsPage title={t('statistics.acquisitionPage.title')}>
      <AcquisitionSummaryCard />
      <ShowByCountry excludeCountries={[Country.BR]}>
        <HelpLink
          title={t('statistics.helpLink.aboutStats')}
          linkURL={t('statistics.helpLink.aboutStatsUrl')}
          previousValue=""
          currentViewTracking={t('statistics.aboutProductsTrackingName')}
          icon="both"
        />
      </ShowByCountry>
    </StatisticsPage>
  );
}

export default StatisticsAcquisitionPage;
